import { createBrowserHistory } from 'history'
/**
 * History called by redux saga
 */
export const history = createBrowserHistory()
